import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DURATION, EASE } from "./animation-config.js";

gsap.registerPlugin(ScrollTrigger);
const IMAGE_SCALE = 1.08;

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

function getMarkOpacity(section) {
  const value = getComputedStyle(section)
    .getPropertyValue("--hero-image-mark-opacity")
    .trim();

  return value ? parseFloat(value) : 0.55;
}

function revealMark(mark, section, timeline) {
  const markOpacity = getMarkOpacity(section);

  timeline.to(mark, { x: 0, opacity: markOpacity }, 0);
  timeline.set(mark, { clearProps: "opacity,x" });
}

function setMarkRevealed(mark) {
  gsap.set(mark, { clearProps: "opacity,x" });
}

function getMarkEnterOffset(section) {
  if (section.classList.contains("hero-image--mark-left-bottom")) {
    return "-50vw";
  }

  return "50vw";
}

function initHeroImageCentered(section) {
  const image = section.querySelector(".hero-image__image");
  const headline = section.querySelector(".hero-image__headline");
  const mark = section.querySelector(".hero-image__mark");

  if (!image && !headline && !mark) {
    return;
  }

  if (reducedMotion) {
    gsap.set(image, { scale: 1 });

    if (headline) {
      gsap.set(headline, { x: 0, opacity: 1 });
    }

    if (mark) {
      setMarkRevealed(mark);
    }

    section.classList.add("is-in-view");
    return;
  }

  if (image) {
    gsap.set(image, { scale: IMAGE_SCALE });
  }

  if (headline) {
    gsap.set(headline, { x: "-50vw", opacity: 0 });
  }

  if (mark) {
    gsap.set(mark, { x: getMarkEnterOffset(section), opacity: 0 });
  }

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      const timeline = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
      });

      if (image) {
        timeline.to(image, { scale: 1 }, 0);
      }

      if (headline) {
        timeline.to(headline, { x: 0, opacity: 1 }, 0);
      }

      if (mark) {
        revealMark(mark, section, timeline);
      }
    },
  });
}

function initHeroImageBottom(section) {
  const image = section.querySelector(".hero-image__image");
  const headline = section.querySelector(".hero-image__headline");
  const mark = section.querySelector(".hero-image__mark");

  if (!image && !headline && !mark) {
    return;
  }

  if (reducedMotion) {
    gsap.set(image, { scale: 1 });
    gsap.set(headline, { y: 0, opacity: 1 });

    if (mark) {
      setMarkRevealed(mark);
    }

    section.classList.add("is-in-view");
    return;
  }

  if (image) {
    gsap.set(image, { scale: IMAGE_SCALE });
  }

  if (headline) {
    gsap.set(headline, { y: 40, opacity: 0 });
  }

  if (mark) {
    gsap.set(mark, { x: "-50vw", opacity: 0 });
  }

  ScrollTrigger.create({
    trigger: section,
    start: "top 70%",
    once: true,
    onEnter: () => {
      section.classList.add("is-in-view");

      const timeline = gsap.timeline({
        defaults: { duration: DURATION, ease: EASE },
      });

      if (image) {
        timeline.to(image, { scale: 1 }, 0);
      }

      if (headline) {
        timeline.to(headline, { y: 0, opacity: 1 }, 0);
      }

      if (mark) {
        revealMark(mark, section, timeline);
      }
    },
  });
}

document.querySelectorAll(".hero-image").forEach((section) => {
  if (section.classList.contains("hero-image--layout-bottom")) {
    initHeroImageBottom(section);
    return;
  }

  initHeroImageCentered(section);
});

window.addEventListener(
  "load",
  () => {
    ScrollTrigger.refresh();
  },
  { once: true },
);
